export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.17-1345.34",
  commitId: "c7cf40125998f8cbbfa23399395b806ad985890b",
  commitTime: "2026-09-17T13:45:34.000Z",
});
